import React from 'react';
import { StepForm } from 'utils';
import { Checkbox, Form, Radio } from 'antd';
import SubmitButton from './SubmitButton';
export const checkBoxOption = [
  { label: 'HR Portal', value: 'hr_portal' },
  {
    label: 'Staff leave  & absence management',
    value: 'absence_management',
  },
  { label: 'Expense reports', value: 'expense_report' },
  { label: 'Time & activities', value: 'time_activities' },
];
const One: React.FC<StepForm> = ({ form_data, onSubmit }) => {
  // const [exist, setExist] = React.useState(false);
  // const [form] = Form.useForm();

  return (
    <>
      <Form initialValues={form_data} onFinish={(value) => onSubmit(value)}>
        <div className="form-wrapper">
          <h1 className="form-wrapper_title"> Creation Type</h1>
          <Radio checked style={{ color: '#000' }}>From an empty user record</Radio>
          {/* <Space>
            <Radio.Group onChange={(v) => setExist(v.target.value)}>
              <Radio value={false}>From an empty user record </Radio>
              <Radio value={true}>From an existing user</Radio>
            </Radio.Group>
          </Space>
          {exist && (
            <div className="mt-5">
              <h1 className="form-wrapper_title mb-5">
                Create from an existing user
              </h1>
              <Item name={'value2'} required>
                <CustomInput title={'value 2'} />
              </Item>
            </div>
          )} */}
        </div>
        <div className="form-wrapper my-5">
          <h1 className="form-wrapper_title">Modules to activate</h1>
          <Form.Item name={'active_modules'}>
            <Checkbox.Group
              options={checkBoxOption}
              onChange={(v) => console.log(v)}
              className="mb-4 is-flex"
              style={{ gap: 148 }}
            />
          </Form.Item>
        </div>
        <Form.Item shouldUpdate>
          {({ getFieldsValue }) => {
            const { active_modules } = getFieldsValue();
            return (
              <button
                disabled={!active_modules}
                type="submit"
                className="add_user_button is-pulled-right is-flex is-justify-content-center is-align-items-center"
              >
                <span>NEXT</span>
                <img src="/icons/back_button.svg" alt="next" />
              </button>
            );
          }}
        </Form.Item>
      </Form>
    </>
  );
};

export default One;
